import { Input, Label } from "reactstrap";

const NormalInput2 = ({
  label,
  value,
  setValue,
  placeholder,
  type,
  labelClassName,
  className,
  options,
  getObjectFromOption,
  inputStyle,
}) => {
  return (
    <div className={`normal-input-2 ${className}`}>
      {label && (
        <Label
          className={labelClassName ? labelClassName : "figma-input-label"}
        >
          {label}
        </Label>
      )}
      {type !== "select" ? (
        <Input
          style={inputStyle}
          type={type}
          placeholder={placeholder}
          onChange={(e) => setValue(e?.target?.value)}
          value={value}
        />
      ) : (
        <Input
          style={inputStyle}
          type="select"
          value={value}
          onChange={(e) => setValue(e?.target?.value)}
          placeholder={placeholder}
        >
          {options?.map((i) => (
            <option
              onClick={() => {
                if (getObjectFromOption) getObjectFromOption(i);
              }}
              selected={
                typeof i === "object"
                  ? (i?.title ?? i?.name) === value
                  : i === value
              }
            >
              {typeof i === "object" ? i?.title ?? i?.name : i}
            </option>
          ))}
        </Input>
      )}
    </div>
  );
};

export default NormalInput2;
